import { useState } from "react";
import { Box } from "@mui/material";

import CommonDrawer from "../../drawer/CommonDrawer";
import { deleteIcon } from "../../images";
import Text from "../../text/Text";
import Button from "../../button/Button";
import { cancel, deleteTxt } from "../../messages";

function DeleteDrawer({
  openDrawer,
  setOpenDrawer,
  deleteTitle,
  handleDelete,
  deleteSubText,
  setActionDrawer,
}) {
  const [buttonLoader, setButtonLoader] = useState(false);

  const handleDeleteClick = async () => {
    setButtonLoader(true);
    try {
      await handleDelete();
    } finally {
      setButtonLoader(false);
    }
  };

  const handleCloseDrawer = () => {
    setOpenDrawer(false);
    setActionDrawer?.(false);
  };

  return (
    <CommonDrawer
      anchor="bottom"
      open={openDrawer}
      onClose={handleCloseDrawer}
      className="delete-drawer"
    >
      <Box className="delete-drawer-container">
        <img src={deleteIcon} height={44} width={44} />
        <Text size={20} font="bold" className="error-text">
          {deleteTitle}
        </Text>
        <Text size={14} font="regular" className="grey-text">
          {deleteSubText}
        </Text>
      </Box>
      <Box className="delete-drawer-actions">
        <Button
          label={cancel}
          variant="outlined"
          color="primary"
          sx={{
            width: "200px",
          }}
          onClick={handleCloseDrawer}
        />
        <Button
          label={deleteTxt}
          loading={buttonLoader}
          variant="contained"
          color="error"
          sx={{
            width: "200px",
          }}
          onClick={handleDeleteClick}
        />
      </Box>
    </CommonDrawer>
  );
}
export default DeleteDrawer;
